import React from 'react';

const CapacityDevelopment = () => {
  return (
    <div>
      CapacityDevelopment
      CapacityDevelopment
    </div>
  );
}

export default CapacityDevelopment;
